import { InjectionToken } from '@angular/core';
import { AITranslator } from '@app/shared/services/translator-ai/translator-ai.service';

export interface TranslatorAPI {
  availability(options: {
    sourceLanguage: string;
    targetLanguage: string;
  }): Promise<'readily' | 'after-download' | 'unavailable'>;
  create(options: { sourceLanguage: string; targetLanguage: string }): Promise<AITranslator>;
}

export interface IFBWindow extends Window {
  Firstbird?: IFBWindowNamespace;
  _jipt: string[][];
  handleOpenURL: (url: string) => NodeJS.Timeout;
  dataLayer: object[];
  Translator?: TranslatorAPI;
}

export interface IFBWindowNamespace {
  // This is a trick to allow app to boot without hash params,
  // which are interfering with angular html5 mode (uri /#access_token... is tried to be matched against a route).
  // Before app bootstrap a full url will be written to this variable and then hash part will be cleaned from url,
  // after that when app bootstraps it will pick up params again from this variable.
  originalHref?: string;
  redirectPath?: string;
  redirectState?: string;
}

export const IFBWindow = new InjectionToken<IFBWindow>('An abstraction over global window object', {
  factory: () => window as unknown as IFBWindow
});
